<template>
  <div id="accountTerminologyForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-text-field v-model="accountTerminology.name" label="Name" :required="true" />
      <v-text-field v-model="accountTerminology.value" label="Value" :required="false" />

      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>
    
<script>
import { getAccountTerminology } from "@/services/accountTerminology";


import { mapActions } from "vuex";



export default {
  name: 'TerminologyForm',
  props: ["id", "isModal"],
  data() {
    return {
      loaded: false,
      valid: false,
      accountTerminology: {
        relations: {

        },
        name: '',
        value: '',

      }
    }
  },
  created() {
    this.setInstace();
  },
  methods: {
    ...mapActions("accountTerminology", ["createAccountTerminology", "updateAccountTerminology"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),

    async handleSubmit() {
      if (this.id) {
        let accountTerminology = this.accountTerminology;
        delete accountTerminology.relations;

        this.updateAccountTerminology(accountTerminology)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("AccountTerminology was updated successfully");
            this.goBack();
          }).catch(() => {
            this.addErrorMessage("Error updating AccountTerminology, please try again later");
          });
      } else {
        let accountTerminology = this.accountTerminology;
        delete accountTerminology.relations;

        this.createAccountTerminology(accountTerminology)
          .then(response => {
            console.log(response);
            this.addSuccessMessage("AccountTerminology was created successfully");
            if (this.isModal) {
              this.onCloseDialog();
            }
            else {
              this.goBack();
            }
          }).catch(() => {
            this.addErrorMessage("Error creating AccountTerminology, please try again later");
          })
      }
    },
    goBack() {
      if (this.isModal) {
        this.onCloseDialog();
      }
      else {
        this.$router.go(-1);
      }
    },
    setInstace() {
      if (this.id) {
        this.accountTerminology.id = this.id;
        getAccountTerminology(this.id)
          .then(response => {
            let instance = response.data;
            for (let property in instance) {
              if (Object.prototype.hasOwnProperty.call(instance, property) && Object.prototype.hasOwnProperty.call(this.accountTerminology, property)) {
                this.accountTerminology[property] = instance[property];
              }
            }
            this.loaded = true;
          })
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {

    },
    onCloseDialog() {
      this.$emit('clicked', 'closeTermDialog')
    },

  },
  components: {

  }
}
</script>
